const AudioPlayerErrors = {
    1: 'AudioPlayer MEDIA_ERR_ABORTED',
    2: 'AudioPlayer MEDIA_ERR_NETWORK',
    3: 'AudioPlayer MEDIA_ERR_DECODE',
    4: 'AudioPlayer MEDIA_ERR_SRC_NOT_SUPPORTED',
} as const;
const AudioPlayerErrorDefaults = {
    UNKNOWN_ERROR: 'AudioPlayer UNKNOWN_ERROR',
} as const;
const isValidErrorCode = (code: number): code is keyof typeof AudioPlayerErrors => {
    return code in AudioPlayerErrors;
};
export const getAudioPlayerError = (code: number) => {
    if (isValidErrorCode(code)) {
        return AudioPlayerErrors[code];
    }
    return AudioPlayerErrorDefaults.UNKNOWN_ERROR;
};
